import { breakpoints, colors } from 'globalStyles'
import styled from 'styled-components'
import { Card } from 'react-bootstrap'

export const pencilIconStyle = {
  width: '20px',
  height: '20px',
}

export const tableHeaderStyle = {
  display: 'table-cell',
  verticalAlign: 'middle',
  width: '50px',
}

export const tableColumnStyle = {
  display: 'table-cell',
  verticalAlign: 'middle',
  textAlign: 'right',
}

export const tableContentStyle = {
  fontWeight: 600,
  color: colors.web_text_black,
}

export const tableSubContentStyle = {
  color: colors.grey,
}

export const StyledCard = styled(Card)`
  margin-top: 24px;
  border-radius: 8px 0 8px 0;
  overflow: hidden; /* clip header/body backgrounds to the rounded corners */
  @media ${breakpoints.desktop}, ${breakpoints.tablet} {
    margin-top: 36px;
  }
  .card-header {
    padding: 12px;
    background-color: ${colors.primary_white};
    height: 72px;
    display: block;
    border-radius: 0; /* let the card's overflow do the clipping */
    border-bottom: 0; /* remove the square bottom line if it leaves a gap */
  }
  .card-title {
    @media ${breakpoints.desktop} {
      margin-left: 15px;
    }
    @media ${breakpoints.tablet} {
      margin-left: 5px;
    }
    font-weight: 600;
    font-size: 20px;
    color: ${colors.dark_blue};
  }
  .card-text {
    @media ${breakpoints.desktop} {
      margin-left: 15px;
    }
    @media ${breakpoints.tablet} {
      margin-left: 5px;
    }

    font-size: 14px;
  }
  .table {
    height: 70px;
  }
  .button {
    width: 96%;
  }
`

export const LocationStyledCard = styled(StyledCard)`
  border-radius: 8px 0 8px 0; /* design radius */
  overflow: visible; /* allow the dropdown menu to extend beyond the card */

  .card-header {
    border-radius: 8px 0 0 0; /* top-left only; overridden inline when collapsed */
  }
`
export const houseBuildingIconStyle = {
  width: '25px',
  height: '20px',
}

export const deliveryInstructionsIconStyle = {
  width: '25px',
  height: '29px',
}

export const StyledSubCard = styled(Card)`
  margin-top: 10px;
  margin-left: 0.75rem;
  margin-right: 0.75rem;
  display: flex;
  justify-self: anchor-center;
  max-width: 96%;
  min-height: 84px;
  height: auto;
  @media (max-width: 400px) {
    min-height: unset;
    height: auto;
  }
  .card-body {
    background-color: ${colors.yellow};
    word-break: break-word;
    white-space: normal;
  }
  .card-text {
    font-size: 14px;
  }
`
export const StyledSpan = styled.span`
  font-weight: 600;
  font-size: 14px;
  margin-right: 15px;
  @media ${breakpoints.desktop} {
    margin-left: 15px;
  }
  @media ${breakpoints.tablet} {
    margin-left: 5px;
  }
`
export const penToSquareIconStyle = {
  width: '25px',
  height: '25px',
}

export const circleInfoIconStyle = {
  width: '20px',
  height: '20px',
}

export const buzzerIconStyle = {
  width: '25px',
  height: '29px',
}

export const CenteredDiv = styled.div`
  display: flex;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 10px;
  @media ${breakpoints.desktop} {
    margin-left: 25px;
  }
  @media ${breakpoints.tablet} {
    margin-left: 15px;
  }
`
export const TermsAndConditionsLink = styled.a.attrs({
  id: 'terms-and-conditions-link',
  target: '_blank',
  rel: 'noreferrer',
})`
  color: ${colors.primary_blue};
`

export const fullWidthDropdown = {
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
  boxSizing: 'border-box',
}
